import { createClient } from '@supabase/supabase-js';

const supabaseUrl     = process.env.REACT_APP_SUPABASE_URL     || 'https://hurfkheambsrlbbxyhhj.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1cmZraGVhbWJzcmxiYnh5aGhqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc1MzY5MTUsImV4cCI6MjA4MzExMjkxNX0.Ia5cgI89ZHDjw_nWywCudLEan2ApXK1magRvsFAeBNc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
